module.exports = __webpack_public_path__ + "static/media/YM34_3.2bdbce47.jpg";